// extracted by mini-css-extract-plugin
module.exports = {"overlay":"ModalContainer_overlay__t5gig","content":"ModalContainer_content__x7U8D","hideScroll":"ModalContainer_hideScroll__rGTvC","bodyOpen":"ModalContainer_bodyOpen__qNLPU"};